export class TaxSettings {

  public id: number;
  public default: string;
  public tip: string;
  public label: string;
  public value: string;
  public options: any;
  public description: string;

}
